import { FC } from 'react';
import clsx from 'clsx';

export interface TypingIndicatorProps {
  name?: string;
  className?: string;
}

export const TypingIndicator: FC<TypingIndicatorProps> = ({ name, className }) => {
  return (
    <div className={clsx('flex items-center gap-2 text-sm text-gray-500', className)}>
      {name && <span className="font-medium">{name} is typing</span>}
      <div className="flex gap-1">
        <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '0ms' }} />
        <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '150ms' }} />
        <span className="w-2 h-2 bg-gray-400 rounded-full animate-bounce" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
};

TypingIndicator.displayName = 'TypingIndicator';
